import { RESPONSIVE_TEXT_BUTTON_CLASS } from "../../lib/touchTarget";
import { Link } from "@tanstack/react-router";
import { Button } from "../ui/button";
import type { NewThreadLandingSurface } from "./newThreadLandingSurface";
import { refreshCmmdForgeRuntimeList } from "../../cmmd/cmmdForgeRuntimeListResource";

export function NewThreadInventoryNotice({ state }: { readonly state: NewThreadLandingSurface }) {
  if (state === "composer") return null;
  return (
    <div
      className="flex min-w-0 flex-wrap items-center justify-between gap-2 text-sm text-muted-foreground"
      role="status"
    >
      <span>
        {state === "loading"
          ? "Loading project choices. You can write your draft now."
          : state === "connect-environment"
            ? "Connect an environment when you are ready to send."
            : "We couldn't load your projects. Your draft is still here."}
      </span>
      {state === "connect-environment" ? (
        <Button
          className={RESPONSIVE_TEXT_BUTTON_CLASS}
          size="sm"
          variant="outline"
          render={<Link to="/settings/environments" />}
        >
          Open Connections
        </Button>
      ) : state === "cloud-catalog-unavailable" ? (
        <Button
          className={RESPONSIVE_TEXT_BUTTON_CLASS}
          size="sm"
          variant="outline"
          onClick={refreshCmmdForgeRuntimeList}
        >
          Try again
        </Button>
      ) : null}
    </div>
  );
}
